import React, { useState } from "react";

// Hooks
import { useDispatch } from "react-redux";

// Actions
import { updateUserStatusByAdmin } from "~/redux/actions/admin-users-actions";
import { success, failure } from "~/redux/actions/snackbar-actions";

// Utils
import { MESSAGES } from "~/utils/message";

// Mui Components
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { Box, CircularProgress } from "@mui/material";

// Icons
import { ModalCrossCIcon } from "~/assets/images";

// Styles
import "./styles.scss";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const ActionModal = (props) => {
  const { openModal, handleCloseModal, selectedUser, getAdminUsers } = props;
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();

  const onSubmit = async () => {
    try {
      setLoading(true);
      let payload = {
        id: selectedUser?.id,
        status: selectedUser?.status === "Blocked" ? "Approved" : "Blocked",
      };
      const response = await dispatch(updateUserStatusByAdmin(payload));
      if (response.status === 200) {
        getAdminUsers();
        dispatch(success(response.data.message));
        handleCloseModal();
      } else {
        dispatch(failure(response?.data?.message));
      }
    } catch (error) {
      dispatch(failure(error?.response?.data?.message || error?.message));
    } finally {
      setLoading(false);
    }
  };

  return (
    <BootstrapDialog
      onClose={handleCloseModal}
      aria-labelledby="customized-dialog-title"
      open={openModal}
      className="userActionModalWrapper"
    >
      <IconButton
        aria-label="close"
        onClick={handleCloseModal}
        sx={{
          position: "absolute",
          right: 5,
          top: 5,
          padding: 0,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <ModalCrossCIcon />
      </IconButton>
      <DialogContent dividers className="userActionModalContent">
        {/* <img height={70} src={Disabled} alt="disabled" /> */}
        <Box className="deleteHeadings">
          <Typography gutterBottom variant="h4">
            {selectedUser?.status === "Blocked"
              ? MESSAGES.ADMIN_DASHBOARD.USERS.USER_ACTION.ENABLE_TITLE
              : MESSAGES.ADMIN_DASHBOARD.USERS.USER_ACTION.DISABLE_TITLE}
          </Typography>
          <Typography gutterBottom>
            {selectedUser?.status === "Blocked"
              ? MESSAGES.ADMIN_DASHBOARD.USERS.USER_ACTION.ENABLE_HEADING
              : MESSAGES.ADMIN_DASHBOARD.USERS.USER_ACTION.DISABLE_HEADING}
          </Typography>
        </Box>
        <Box className="userActionModalBtns">
          <Button onClick={handleCloseModal}>
            {MESSAGES.ADMIN_DASHBOARD.USERS.USER_ACTION.CANCEL_BUTTON}
          </Button>
          <Button onClick={onSubmit}>
            {loading ? (
              <CircularProgress
                sx={{
                  color: "white",
                  width: "25px !important",
                  height: "25px !important",
                }}
              />
            ) : (
              MESSAGES.ADMIN_DASHBOARD.USERS.USER_ACTION.SUBMIT_BUTTON
            )}
          </Button>
        </Box>
      </DialogContent>
    </BootstrapDialog>
  );
};

export default ActionModal;
